// Google Analytics utility functions

export const GA_TRACKING_ID = "G-05XYDK99ED";

// Initialize gtag
export const gtag = {
  // Page view tracking
  pageview: (url: string) => {
    if (typeof window !== "undefined" && window.gtag) {
      console.log("📊 Google Analytics: Page view tracked", { url });
      window.gtag("config", GA_TRACKING_ID, {
        page_path: url,
      });
    } else {
      console.warn("⚠️ Google Analytics: gtag not available", {
        hasWindow: typeof window !== "undefined",
        hasGtag: typeof window !== "undefined" && !!window.gtag,
      });
    }
  },

  // Event tracking
  event: ({
    action,
    category,
    label,
    value,
  }: {
    action: string;
    category?: string;
    label?: string;
    value?: number;
  }) => {
    if (typeof window !== "undefined" && window.gtag) {
      console.log("📊 Google Analytics: Event tracked", {
        action,
        category,
        label,
        value,
      });
      window.gtag("event", action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    } else {
      console.warn("⚠️ Google Analytics: gtag not available for event", {
        action,
        category,
        label,
        hasWindow: typeof window !== "undefined",
        hasGtag: typeof window !== "undefined" && !!window.gtag,
      });
    }
  },
};

// Helper function to track button clicks
export const trackButtonClick = (
  buttonName: string,
  location?: string
) => {
  const label = `${buttonName}${location ? ` - ${location}` : ""}`;
  console.log("🔘 Button click tracked:", { buttonName, location, label });
  gtag.event({
    action: "click",
    category: "button",
    label: label,
  });
};

// Helper function to track link clicks
export const trackLinkClick = (linkName: string, url: string) => {
  gtag.event({
    action: "click",
    category: "link",
    label: linkName,
  });
};

// Declare gtag function on window
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (
      command: string,
      targetId: string,
      config?: Record<string, any>
    ) => void;
  }
}

